{
    "m3WorkflowBuilder": {
        "title": "M3 Workflow Builder",
        "subtitle": "Velg program og transaksjon for å vise metadata",
        "connection": "Tilkobling",
        "connectionPlaceholder": "Velg en tilkobling...",
        "program": "Program",
        "programPlaceholder": "Søk og velg et program...",
        "programCount": "{count} programmer",
        "transaction": "Transaksjon",
        "transactionPlaceholder": "Søk og velg en transaksjon...",
        "inputFields": "Inndatafelt",
        "outputFields": "Utdatafelt",
        "fieldCount": "{count} felt",
        "fieldName": "Navn",
        "fieldDescription": "Beskrivelse",
        "fieldType": "Type",
        "fieldLength": "Lengde",
        "fieldMandatory": "Obligatorisk",
        "required": "Påkrevd",
        "noInputFields": "Ingen inndatafelt",
        "noOutputFields": "Ingen utdatafelt",
        "createWorkflow": "Opprett arbeidsflyt",
        "workflowName": "Arbeidsflytnavn",
        "workflowNamePlaceholder": "Skriv inn arbeidsflytnavn",
        "create": "Opprett",
        "creating": "Oppretter...",
        "workflowCreated": "Opprettet",
        "workflowCreatedSuccess": "Arbeidsflyt opprettet!",
        "workflowId": "Arbeidsflyt-ID",
        "workflowCreateFailed": "Kunne ikke opprette arbeidsflyt",
        "runWorkflow": "Kjør arbeidsflyt",
        "runInfo": "Arbeidsflyten kan nå brukes av App Builder. Hvis du vil, kan du teste den nedenfor.",
        "run": "Kjør arbeidsflyt",
        "running": "Kjører...",
        "workflowResult": "Arbeidsflytresultat",
        "recordCount": "{count} post(er)",
        "noRecords": "Ingen poster returnert",
        "error": "Feil",
        "field": "Felt",
        "loadConnectionsError": "Kunne ikke laste tilkoblinger",
        "loadProgramsError": "Kunne ikke laste programmer",
        "loadTransactionsError": "Kunne ikke laste transaksjoner",
        "loadFieldsError": "Kunne ikke laste transaksjonsfelt",
        "createWorkflowError": "Kunne ikke opprette arbeidsflyt",
        "runWorkflowError": "Kunne ikke kjøre arbeidsflyt",
        "menuLabel": "M3 Workflow Builder"
    }
}
